module.exports = __webpack_public_path__ + "img/qgsyt6.fab9c1fe.png";